import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { AutosaveResponseData, UpdateDocumentsData } from "../../form-details.model";

@Injectable()
export class FormDetailsActionsService {
  private readonly addOwnerSubject: Subject<void> = new Subject();
  addOwner$: Observable<void> = this.addOwnerSubject.asObservable();
  addOwner = (): void => this.addOwnerSubject.next();

  private readonly removeOwnerSubject: Subject<number> = new Subject();
  removeOwner$: Observable<number> = this.removeOwnerSubject.asObservable();
  removeOwner = (arrayFormIndex: number): void => this.removeOwnerSubject.next(arrayFormIndex);

  private readonly autosaveResponseSubject: BehaviorSubject<AutosaveResponseData> = new BehaviorSubject(null);
  autosaveResponse$: Observable<AutosaveResponseData> = this.autosaveResponseSubject.asObservable();
  autosaveResponse = (data: AutosaveResponseData): void => this.autosaveResponseSubject.next(data);

  private readonly updateDocumentsDataSubject: Subject<UpdateDocumentsData> = new Subject();
  updateDocumentsData$: Observable<UpdateDocumentsData> = this.updateDocumentsDataSubject.asObservable();
  updateDocumentsData = (data: UpdateDocumentsData): void => this.updateDocumentsDataSubject.next(data);

  private readonly markInvalidSectionsSubject: Subject<boolean> = new Subject();
  markInvalidSections$: Observable<boolean> = this.markInvalidSectionsSubject.asObservable();
  markInvalidSections = (canMarkAsInvalid: boolean): void => this.markInvalidSectionsSubject.next(canMarkAsInvalid);

  private readonly expandAllSectionsSubject: Subject<void> = new Subject();
  expandAllSections$: Observable<void> = this.expandAllSectionsSubject.asObservable();
  expandAllSections = (): void => this.expandAllSectionsSubject.next();
}
